import React, { ChangeEventHandler, ComponentProps } from 'react';

import { ClearButton } from 'components/Button';
import { Input } from 'components/Input';
import { matchSize } from 'utils/responsive';

type Props = {
  query: string;
  placeholder?: string;
  xsPlaceholder?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  clearQuery: () => void;
  presentation: ComponentProps<typeof Input>['presentation'];
  'data-qa-id'?: string;
};

export function SearchQueryInputContainer({
  query,
  placeholder,
  xsPlaceholder,
  onChange,
  clearQuery,
  presentation,
  'data-qa-id': dataQaId,
}: Props) {
  return (
    <Input
      inputProps={{
        placeholder: matchSize({
          xs: true,
        })
          ? xsPlaceholder
          : placeholder,
        value: query,
        onChange,
        'data-qa-id': dataQaId,
        'aria-label': placeholder,
      }}
      suffix={
        query !== '' && (
          <ClearButton
            onClick={clearQuery}
            data-qa-id="search-input-clear"
            aria-label={getText('Clear search input')}
          />
        )
      }
      presentation={presentation}
      fullHeight
    />
  );
}
